<ion-header>
    <ion-toolbar color="secondary">
        <ng-container *ngIf="fromMenu; else logo">
            <ion-title>Mission</ion-title>

            <ion-buttons slot="end">
                <ion-button (click)="onClose()">
                    <i class="material-symbols-outlined">close</i>
                </ion-button>
            </ion-buttons>
        </ng-container>
        <ng-template #logo>
            <app-logo></app-logo>
        </ng-template>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen [scrollEvents]="true" (ionScroll)="onScroll($event)">
    <main #main class="center">
        <section>
            <div class="icons">
                <ion-icon slot="start" src="/assets/svg/trailer-5.svg"></ion-icon>
                <ion-icon slot="start" src="/assets/svg/trailer-1.svg"></ion-icon>
                <ion-icon slot="start" src="/assets/svg/trailer-6.svg"></ion-icon>
            </div>
            <h2>Need to move your trailer or cargo?</h2>
            <p>
                Drive & Tow connects you with local pickup truck drivers who can handle pickups and drop-offs quickly, and at
                affordable price. Simply enter your trip details and get matched with a driver who fits your needs.
            </p>

            <div class="icons">
                <ion-icon slot="start" src="/assets/svg/vehicle-4.svg"></ion-icon>
                <ion-icon slot="start" src="/assets/svg/vehicle-5.svg" class="van"></ion-icon>
            </div>
            <h2>Own a pickup truck or a van?</h2>
            <p>
                Turn it into extra income on your schedule. Browse requests in your area, choose the jobs you want and get paid for
                towing or delivering cargo such as furniture, appliances, or building materials.
            </p>
        </section>
    </main>
</ion-content>

<ion-footer class="ion-no-border">
    <ion-button type="button" expand="block" [disabled]="disabled$ | async" (click)="onClose()"> Close </ion-button>
</ion-footer>
